module.exports = __webpack_public_path__ + "img/ck.9bc72683.svg";